import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Container from "@/components/ui/container";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowLeft, Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-black">
      <SEO 
        title="Página não encontrada - 404"
        description="A página que você procura não foi encontrada. Explore nossas soluções Fluig, catálogo de FluigApps ou entre em contato conosco para encontrar o que precisa."
        keywords={['página não encontrada', 'erro 404', 'future station', 'soluções fluig']}
        type="website"
      />
      <Header />
      
      <main className="pt-24">
        <Container className="py-20">
          <div className="text-center max-w-2xl mx-auto">
            <div className="mb-8">
              <div className="w-24 h-24 mx-auto mb-6 bg-fs-purple-500/20 rounded-full flex items-center justify-center">
                <AlertTriangle className="w-12 h-12 text-fs-purple-500" />
              </div>
              
              <h1 className="text-6xl md:text-8xl font-bold fs-gradient-text mb-4">
                404
              </h1>
              
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
                Página não encontrada
              </h2>
              
              <p className="text-xl text-white/70 mb-8 leading-relaxed">
                A página que você está procurando não existe ou foi movida. 
                Explore nossas soluções Fluig ou entre em contato conosco.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <Link to="/">
                <Button variant="fs-primary" size="lg">
                  <Home className="w-5 h-5 mr-2" />
                  Página Inicial
                </Button>
              </Link>
              
              <Link to="/flows">
                <Button variant="fs-outline" size="lg">
                  <ArrowLeft className="w-5 h-5 mr-2" />
                  Ver Soluções
                </Button>
              </Link>
            </div>
            
            <div className="mt-12 pt-8 border-t border-fs-purple-500/20">
              <p className="text-white/70 text-sm">
                Rota solicitada: <code className="bg-gray-900/50 px-2 py-1 rounded text-fs-purple-400">{location.pathname}</code>
              </p>
            </div>
          </div>
        </Container>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
